import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const gridBreakpoints = [768, 1280];
export const isFlushSetForBreakPoint = (flush, breakPoint) => {
    if (typeof flush === 'boolean') {
        // single value just return
        return flush;
    }
    // return array value
    return flush[breakPoint];
};
const BaseGridStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }) => Array.isArray(justifyContent) ? justifyContent[0] : justifyContent};
  align-items: ${({ align }) => align};
  margin: 0
    ${({ theme, flush }) => 
// for small devices
isFlushSetForBreakPoint(flush, 0)
    ? -theme.GridBaseGridSmall0GutterSize / 2
    : theme.GridBaseGridSmall0GutterSize / 2}px;

  @media (min-width: ${gridBreakpoints[0]}px) {
    margin: 0
      ${({ theme, flush }) => 
// for medium devices
isFlushSetForBreakPoint(flush, 1)
    ? -theme.GridBaseGridMedium0GutterSize / 2
    : theme.GridBaseGridMedium0GutterSize}px;

    justify-content: ${({ justifyContent }) => Array.isArray(justifyContent) ? justifyContent[1] : justifyContent};
  }

  @media (min-width: ${gridBreakpoints[1]}px) {
    margin: 0
      ${({ theme, flush }) => 
// for large devices
isFlushSetForBreakPoint(flush, 2)
    ? -theme.GridBaseGridLarge0GutterSize / 2
    : theme.GridBaseGridLarge0GutterSize}px;
    justify-content: ${({ justifyContent }) => Array.isArray(justifyContent) ? justifyContent[2] : justifyContent};
  }
`;
/**
 * The grid is comprised of two elements. The `<BaseGrid>` tag and the `<BaseGridItem>`.
 *
 * The `<BaseGrid>` is the outer container that holds all the grid items
 */
export const BaseGrid = ({ children, flush = false, align = 'flex-start', justifyContent = 'start', className, ...rest }) => {
    return (_jsx(BaseGridStyled, { className: className, align: align, flush: flush, justifyContent: justifyContent, ...rest, children: children }));
};
//# sourceMappingURL=base-grid.js.map